import React from 'react'
import { AppSidebar, AppFooter, AppHeader } from './index'
import AppRouter from 'src/navigation/AppRouter'

const DefaultLayout = ({ user }: any) => {
  return (
    <div>
      <AppSidebar user={user} />
      <div className="wrapper d-flex flex-column min-vh-100">
        <AppHeader />
        <div className="body flex-grow-1">
          <AppRouter />
        </div>
        <AppFooter user={user} />
      </div>
    </div>
  )
}

export default DefaultLayout
